import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import Login_Right from "../../../assets/LOGO HRIS 6.png";
import LoginImg from "../../../assets/login-right.jpg"; // Background image

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [employeeNo, setEmployeeNo] = useState("");

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  };

  const getCookie = (name) => {
    const cookieArr = document.cookie.split("; ");
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split("=");
      if (name === cookiePair[0]) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  };

  useEffect(() => {
    const employeeNoCookie = getCookie("employee_no");
    if (employeeNoCookie) {
      setEmployeeNo(JSON.parse(employeeNoCookie));
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://back-ayurveda.erp-quortech.com/v1/hris/user/userLogin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: email,
            password: password,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { user_token, ...userDetails } = data;

        // Save the token and user info to cookies
        setCookie("token", user_token, 7); // Cookie expires in 7 days
        setCookie("user", JSON.stringify(userDetails), 7);
        setCookie("employee_no", userDetails.employee_no, 7); // Cookie expires in 7 days
        localStorage.setItem("token", user_token);

        // Navigate to the dashboard
        navigate("/home");
      } else {
        const errorData = await response.json();
        setLoginError(errorData.message || "Invalid email or password");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setLoginError("An error occurred. Please try again.");
    }
  };

  return (
    <div
      className="flex h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${LoginImg})` }} // Set background image
    >
      <div className="flex justify-center items-center w-1/2">
        <div className="bg-white bg-opacity-90 p-10 rounded-2xl shadow-lg w-[512px]">
          <div className="mb-5 text-center">
            <img
              src={Login_Right}
              alt="Logo"
              className="w-[150px] h-[150px] mb-5 mx-auto"
            />
          </div>

          <h2 className="text-[35px] font-semibold text-gray-800 mb-4 text-center">
            Login
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Email input */}
            <div className="flex flex-col w-full">
              <label
                htmlFor="email"
                className="text-md font-semibold relative top-2 ml-[7px] px-[3px] bg-gray-100 rounded-[20px] w-fit"
              >
                Email
              </label>
              <input
                id="email"
                placeholder="Enter your email / ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border-black px-[10px] py-[11px] text-ml bg-white border-2 rounded-[54px] h-[56px] w-full focus:outline-none placeholder:text-black/25"
              />
            </div>
            <div className="flex flex-col w-full">
              <label
                htmlFor="password"
                className="text-md font-semibold relative top-2 ml-[7px] px-[3px] bg-gray-100 rounded-[20px] w-fit z-50"
              >
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="border-black px-[10px] py-[11px] text-ml bg-white border-2 rounded-[54px] h-[56px] w-full focus:outline-none placeholder:text-black/25"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 flex items-center pr-[10px] focus:outline-none"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FiEyeOff className="text-[#252C58] h-[20px] w-[20px]" />
                  ) : (
                    <FiEye className="text-[#252C58] h-[20px] w-[20px]" />
                  )}
                </button>
              </div>
            </div>
            <div className="mt-[20px] text-red-500">
              {loginError && <p>{loginError}</p>}
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input type="checkbox" id="remember" className="mr-2" />
                <label htmlFor="remember" className="text-sm text-gray-600">
                  Remember me
                </label>
              </div>
            </div>
            <div className="mt-[40px]">
              <button
                type="submit"
                className="w-full bg-[#508D4E] text-[25px] text-white font-bold py-2 focus:outline-none rounded-[63px]"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="w-1/2"></div> {/* Empty right half */}
    </div>
  );
}

export default Login;
